import { useState, useEffect } from 'react'
import {
  requestPushPermission,
  subscribeToPush,
  unsubscribeFromPush,
  getNotificationPreferences,
  saveNotificationPreferences,
} from '../services/notificationService'

type Prefs = { push_enabled: boolean; whatsapp_notify: boolean; days_before: number }

export function useNotifications(userId?: string | null) {
  const [permission, setPermission] = useState<NotificationPermission>(
    typeof Notification !== 'undefined' ? Notification.permission : 'default'
  )
  const [prefs, setPrefs] = useState<Prefs>({ push_enabled: false, whatsapp_notify: false, days_before: 3 })
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (typeof Notification !== 'undefined') {
      setPermission(Notification.permission)
    }
  }, [])

  useEffect(() => {
    if (!userId) return
    setLoading(true)
    getNotificationPreferences()
      .then(p => { if (p) setPrefs(p) })
      .catch(() => {})
      .finally(() => setLoading(false))
  }, [userId])

  const requestPermission = async () => {
    const result = await requestPushPermission()
    setPermission(result)
    if (result === 'granted') await subscribeToPush()
  }

  const togglePush = async (enabled: boolean) => {
    const updated = { ...prefs, push_enabled: enabled }
    setPrefs(updated)
    await saveNotificationPreferences(updated)
    if (enabled && permission === 'granted') await subscribeToPush()
    if (!enabled) await unsubscribeFromPush()
  }

  const saveDaysBefore = async (days: number) => {
    const updated = { ...prefs, days_before: days }
    setPrefs(updated)
    await saveNotificationPreferences(updated)
  }

  const toggleWhatsApp = async (enabled: boolean) => {
    const updated = { ...prefs, whatsapp_notify: enabled }
    setPrefs(updated)
    await saveNotificationPreferences(updated)
  }

  return { permission, prefs, loading, requestPermission, togglePush, saveDaysBefore, toggleWhatsApp }
}
